import React from 'react'

import { i18n } from '@zet/localization'
import {
  CustomBottomSheet,
  PaymentFailureProps,
  useSubscriptionStore,
} from '@zet/zet-prime'

const PaymentFailure = ({
  isVisible,
  onClose,
  onRetry,
}: PaymentFailureProps) => {
  const subscription = useSubscriptionStore((state: any) => state.subscription)

  const handleTryAgain = () => {
    onRetry()
    onClose()
  }

  const handleMaybeLater = () => {
    onClose()
  }

  return (
    <CustomBottomSheet
      isVisible={isVisible}
      onClose={onClose}
      iconImage={require('@zet/zet-prime/assets/images/failedPayment.png')}
      headerText={i18n.t('zetPrime.paymentFailure')}
      subHeaderText={i18n.t('zetPrime.paymentFailureDescription')}
      earningsWithZetPrime={subscription?.earnings}
      buttons={[
        {
          text: i18n.t('zetPrime.tryAgain'),
          onPress: handleTryAgain,
          variant: 'primary',
        },
        {
          text: i18n.t('zetPrime.maybeLater'),
          onPress: handleMaybeLater,
          className: 'bg-primary-10 text-primary-100',
          textStyle: 'text-primary-100',
        },
      ]}
    />
  )
}

export default PaymentFailure
